import { useId } from "react";

export default function Input({
  type = "text",
  label,
  placeholder = "",
  value,
  onChange,
  ...restProps
}) {
  const id = useId();

  return (
    <div className="form-floating mb-3">
      <input
        id={id}
        type={type}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...restProps}
      />
      {label && <label htmlFor={id}>{label}</label>}
    </div>
  );
}
